import React, { memo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  Container,
  MenuItem,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import logo from "../../../assets/images/FareTrack-Rebranding.logo.webp";
import { HEADER_CONSTANTS } from "../../../utils/constants/headerConstants";
import LinkField from "../../common/links/linkField";
import "./header.scss";

const Header = () => {
  const navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = useState(null);

  const languageLabel = window?.Weglot?.getCurrentLang()
    ? window?.Weglot?.getCurrentLang()
    : localStorage.getItem("wglang");

  const languageName = window?.Weglot?.getCurrentLang()
    ? window?.Weglot?.getLanguageName(languageLabel)
    : "English";

  const [languageFlag, setLanguageFlag] = useState({ language: languageName });
  const route_path = window?.location?.pathname;

  // Handle language select for the site 
  const handclickLanguage = (e, language, img) => {
    setLanguageFlag({
      language: window?.Weglot?.getLanguageName(language),
      img: img,
    });
    window.Weglot.switchTo(e?.target?.value);
  };

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const HandleLogin = () => {
    navigate("login");
  };

  let availableLanguages = window?.Weglot?.options?.languages
    ? window?.Weglot?.options?.languages
      ?.map((language) =>  language?.language_to)
      .concat(window?.Weglot?.options?.language_from)
      .sort((a, b) => a?.localeCompare(b))
    : [];

  return (
    <div className="header-style">
      <AppBar position="fixed" className="headermenu">
        <Container>
          <Toolbar disableGutters>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ flexGrow: 1, mr: 2, display: { xs: "none", md: "flex" } }}
            >
              <Link to="/" className="logo">
                <img src={logo} width="212" height="69" alt="FareTrack" />
              </Link>
            </Typography>
            {/* Mobile view Menu start */}
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}
            >
              <Link to="/" className="logo">
                <img src={logo} width="212" height="69" alt="FareTrack" />
              </Link>
            </Typography>
            <Box sx={{ flexGrow: 0, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                className="menubtn"
              >
                <span className="navbar-toggler-icon"></span>
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{ display: { xs: "block", md: "none" }, mt: "42px" }}
                className="mobilemenu"
              >
                {HEADER_CONSTANTS?.LINKS?.map((routes, index) =>
                  routes?.link ? (
                    <MenuItem key={index}>
                      <LinkField link={routes?.link} name={routes?.name} />
                    </MenuItem>
                  ) : (
                    <li className="product link" key={index}>
                      <span>{routes?.name}</span>
                      <span>
                        <ExpandMoreIcon />
                      </span>
                      {routes.products && (
                        <ul className={routes?.name === "Business Intelligence" ? "drop_down extend-width" : "drop_down"}>
                          {routes.products.map((child, childIndex) => (
                            <li key={`${childIndex}${index}`}>
                              <LinkField
                                link={child?.link}
                                name={child?.name}
                              />
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  )
                )}
                <MenuItem>
                  <Button onClick={HandleLogin} className="login-btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="1em"
                      viewBox="0 0 512 512"
                    >
                      <path d="M217.9 105.9L340.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM352 416l64 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"></path>
                    </svg>{" "}
                    {HEADER_CONSTANTS?.LOGIN_BUTTON.label}
                  </Button>
                </MenuItem>
              </Menu>
            </Box>
            {/* Desktop and ipad view menu */}
            <Box
              sx={{ flexGrow: 0, display: { xs: "none", md: "flex" } }}
              className="menusection"
            >
              {HEADER_CONSTANTS?.LINKS?.map((routes, index) =>
                routes?.link ? (
                  <MenuItem
                    key={index}
                    className={
                      route_path ===
                        `/${routes?.link === "/" ? "isValue?.emptyString" : routes?.link}`
                        ? "active-menu"
                        : "dd"
                    }
                  >
                    <LinkField link={routes?.link} name={routes?.name} />
                    <span className="active-img"></span>
                  </MenuItem>
                ) : (
                  <li
                    key={index}
                    className={
                      route_path ===
                        `/${routes?.products?.find(
                          (item) => `/${item.link}` === route_path
                        )?.link
                        }`
                        ? "active-menu product link"
                        : "product link"
                    }
                  >
                    <span>{routes?.name}</span>
                    <span className="active-img"></span>
                    <span>
                      <ExpandMoreIcon />
                    </span>
                    {routes.products && (
                      <ul className={routes?.name === "Business Intelligence" ? "drop_down extend-width" : "drop_down"}>
                        {routes.products.map((child, childIndex) => (
                          <li
                            key={`${childIndex}${index}`}
                            className="sub-menu"
                          >
                            <LinkField link={child?.link} name={child?.name} />
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                )
              )}
              <MenuItem className="languages no-translate " >
                <div className="dropdown" >
                  <Button className="dropbtn"  >
                    <span>{languageFlag.language}</span>
                    <KeyboardArrowDownIcon />
                  </Button>
                  <div className="dropdown-content">
                    {availableLanguages?.filter((data) => data !== languageLabel)?.map((lan, index) => (
                      <Button key={index} value={lan} onClick={(e) => handclickLanguage(e, lan)}>
                        <>{window?.Weglot?.getLanguageName(lan)}</>
                      </Button>
                    ))}
                  </div>
                </div>
              </MenuItem>
              <MenuItem>
                <Button onClick={HandleLogin} className="login-btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="1em"
                    viewBox="0 0 512 512"
                  >
                    <path d="M217.9 105.9L340.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM352 416l64 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"></path>
                  </svg>{" "}
                  {HEADER_CONSTANTS?.LOGIN_BUTTON.label}
                </Button>
              </MenuItem>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
};

export default memo(Header);
